import { FC } from "react";
import { MAIN_PRIMARY_1_COLOR } from "shared/consts";

type Props = {
  fill?: string;
};

export const SignOutIcon: FC<Props> = ({ fill = MAIN_PRIMARY_1_COLOR }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 4.5H15V3H8C6.34315 3 5 4.34315 5 6V18C5 19.6569 6.34315 21 8 21H15V19.5H8C7.17157 19.5 6.5 18.8284 6.5 18V6C6.5 5.17157 7.17157 4.5 8 4.5ZM14.1125 15.1836L15.1716 16.2426L16.2322 15.182L18.7071 12.7071C19.0976 12.3166 19.0976 11.6834 18.7071 11.2929L16.2322 8.81802L15.1716 7.75736L14.1125 8.81641L16.5461 11.25L9 11.25V12.75L16.5461 12.75L14.1125 15.1836Z"
      fill={fill}
    />
  </svg>
);